import React from 'react';
import { isAdmin } from '../lib/roles';

function Header() {
  const admin = isAdmin();
  return (
    <header className="app-header">
      <div className="app-header__mark">EC</div>
      <div className="app-header__text">
        <p className="app-header__eyebrow">{admin ? 'Control Plane' : 'Workspace'}</p>
        <h1 className="app-header__title">Enterprise Claude Skills</h1>
      </div>
    </header>
  );
}

export default Header;
